export const ProductColor = [
  {
    id: "starlight",
    label: "Ánh sao",
    hex: "#F5F5F5",
    available: true,
  },
  {
    id: "silver",
    label: "Bạc",
    hex: "#E3E4E5",
    available: true,
  },
  {
    id: "coral",
    label: "Cam san hô",
    hex: "#FF6F61",
    available: true,
  },
  {
    id: "black",
    label: "Đen",
    hex: "#3C4042",
    available: true,
  },
  {
    id: "jetblack",
    label: "Đen bóng",
    hex: "#1B1B1D",
    available: true,
  },
  {
    id: "spaceblack",
    label: "Đen không gian",
    hex: "#4A4B4D",
    available: true,
  },
  {
    id: "midnight",
    label: "Đen nửa đêm",
    hex: "#2C2D30",
    available: true,
  },
  {
    id: "red",
    label: "Đỏ",
    hex: "#E74C3C",
    available: true,
  },
  {
    id: "pink",
    label: "Hồng",
    hex: "#F2ADDA",
    available: true,
  },
  {
    id: "rosepink",
    label: "Hồng vàng",
    hex: "#FFDAB9",
    available: true,
  },
  {
    id: "purple",
    label: "Tím",
    hex: "#781DBC",
    available: true,
  },
  {
    id: "darkpurple",
    label: "Tím đậm",
    hex: "#4C2F78",
    available: true,
  },
  {
    id: "lightpurple",
    label: "Tím nhạt",
    hex: "#D9A2E3",
    available: true,
  },
  {
    id: "blacktitanium",
    label: "Titan đen",
    hex: "#3F4042",
    available: true,
  },
  {
    id: "deserttitanium",
    label: "Titan sa mạc",
    hex: "#C0A48F",
    available: true,
  },
  {
    id: "whitetitanium",
    label: "Titan trắng",
    hex: "#F2F1EB",
    available: true,
  },
  {
    id: "naturaltitanium",
    label: "Titan tự nhiên",
    hex: "#BAB4A9",
    available: true,
  },
  {
    id: "bluetitanium",
    label: "Titan xanh dương",
    hex: "#3E4555",
    available: true,
  },
  {
    id: "white",
    label: "Trắng",
    hex: "#FAFAFA",
    available: true,
  },
  {
    id: "yellow",
    label: "Vàng",
    hex: "#FFD700",
    available: true,
  },
  {
    id: "blue",
    label: "Xanh dương",
    hex: "#007AFF",
    available: true,
  },
  {
    id: "lightblue",
    label: "Xanh dương nhạt",
    hex: "#87CEEB",
    available: true,
  },
  {
    id: "green",
    label: "Xanh lá",
    hex: "#34C759",
    available: true,
  },
  {
    id: "alpinegreen",
    label: "Xanh lá Alpine",
    hex: "#A3C1AD",
    available: true,
  },
  {
    id: "darkgreen",
    label: "Xanh lá đậm",
    hex: "#006400",
    available: true,
  },
  {
    id: "lightgreen",
    label: "Xanh lá nhạt",
    hex: "#98FB98",
    available: true,
  },
  {
    id: "midnightgreen",
    label: "Xanh lá nửa đêm",
    hex: "#4E5850",
    available: true,
  },
  {
    id: "ultramarine",
    label: "Xanh lam sẫm",
    hex: "#41465A",
    available: true,
  },
  {
    id: "teal",
    label: "Xanh mòng két",
    hex: "#B0D4D2",
    available: true,
  },
  {
    id: "pacificblue",
    label: "Xanh Thái Bình Dương",
    hex: "#0A84FF",
    available: true,
  },
  {
    id: "spacegray",
    label: "Xám không gian",
    hex: "#8E8E93",
    available: true,
  },
  {
    id: "graphite",
    label: "Xám than chì",
    hex: "#3E3E42",
    available: true,
  },
  {
    id: "burgundy",
    label: "Đỏ Burgundy",
    hex: "#541421",
    available: true,
  },
  {
    id: "glacierBlue",
    label: "Băng thanh",
    hex: "#E6F2FF",
    available: true,
  },
];

export const Storage = [
  {
    size: "16GB",
    available: true,
  },
  {
    size: "32GB",
    available: true,
  },
  {
    size: "64GB",
    available: true,
  },
  {
    size: "128GB",
    available: true,
  },
  {
    size: "256GB",
    available: true,
  },
  {
    size: "512GB",
    available: true,
  },
  {
    size: "1TB",
    available: true,
  },
  {
    size: "2TB",
    available: true,
  },
];

export const Category = [
  { id: "iPhone", label: "iPhone" },
  { id: "iPad", label: "iPad" },
  { id: "watch", label: "Watch" },
  { id: "airpods", label: "AirPods" },
  { id: "airtag", label: "AirTag" },
  { id: "accessories", label: "Phụ kiện" },
];

export const Label = [
  { id: "bestSeller", label: "Bán chạy" },
  { id: "newArrival", label: "Hàng mới" },
  { id: "featured", label: "Nổi bật" },
];

export const PaymentMethods = [
  { id: "cash", label: "Tiền mặt" },
  { id: "creditCard", label: "Thẻ tín dụng" },
  { id: "bankTransfer", label: "Chuyển khoản" },
  { id: "installment", label: "Trả góp" },
];
